const actions = {
  edit: 'edit',
  hide: 'hide',
  delete: 'delete',
  detail: 'detail',
};


export default actions;


// WEBPACK FOOTER //
// ./src/constants/actions.js